// @flow
import React, { Component } from 'react';

type Props = {
    load: () => Promise<*>,
    entry: string
};

export default class Loader extends Component<Props, any> {
    state = {};

    loadComponent = async (props: Props) => {
        const { load } = props;

        try {
            const component = await load();

            this.setState({ component });
        } catch (err) {
            console.error(err);
        }
    };

    componentDidMount() {
        this.loadComponent(this.props);
    }

    render() {
        const { load, ...props } = this.props; // eslint-disable-line no-unused-vars
        const { component: Child } = this.state;
        return Child ? <Child {...props} /> : null;
    }
}



// WEBPACK FOOTER //
// ./src/components/routing/loader/index.js